export default "__VITE_ASSET__DWJbedOv__"